import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Wallet, Ticket, X, AlertCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { formatCoins } from "../lib/format";

const THRESHOLD = 100;

export default function LowBalanceNudge() {
  const { user } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const coins = user?.coins ?? 0;

  useEffect(() => { if (coins >= THRESHOLD) setDismissed(false); }, [coins]);

  if (!user || user.role === "admin" || coins >= THRESHOLD || dismissed) return null;
  if (pathname.startsWith("/app/payments")) return null;

  return (
    <div className="relative z-20 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-4" data-testid="low-balance-nudge">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-amber-500/40 bg-gradient-to-r from-amber-500/15 to-fuchsia-500/10 px-4 py-3">
        <div className="flex items-center gap-2.5 flex-1">
          <div className="grid place-items-center h-9 w-9 rounded-xl bg-amber-500/20 text-amber-300 shrink-0">
            <AlertCircle size={18} />
          </div>
          <div>
            <p className="text-sm font-bold text-amber-100">{t("lowBalanceTitle")}</p>
            <p className="text-xs text-slate-300">{coins <= 0 ? t("lowBalanceZero") : `${t("lowBalanceMsg")} (${formatCoins(coins)})`}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => nav("/app/payments")} data-testid="nudge-add-money" className="flex items-center gap-1.5 btn-gold rounded-xl px-4 py-2 text-sm font-bold">
            <Wallet size={15} /> {t("addMoney")}
          </button>
          <button onClick={() => nav("/app/payments")} data-testid="nudge-promo" className="flex items-center gap-1.5 rounded-xl border border-fuchsia-400/40 bg-fuchsia-500/10 px-3 py-2 text-sm font-bold text-fuchsia-200">
            <Ticket size={15} /> {t("promoCode")}
          </button>
          <button onClick={() => setDismissed(true)} data-testid="nudge-dismiss" className="h-8 w-8 grid place-items-center rounded-full text-slate-400 hover:text-white">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
